import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=4098f0e0&scoped=true&"
import script from "./payment-method.vue?vue&type=script&lang=js&"
export * from "./payment-method.vue?vue&type=script&lang=js&"
import style0 from "./payment-method.vue?vue&type=style&index=0&id=4098f0e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098f0e0",
  null
  
)

export default component.exports